import Enumeration from "domain/Enumeration";


const IdTypeEnum = new Enumeration({
    SA_ID: "SA_ID",
    ASYLUM_PAPER: "ASYLUM_PAPER",
    FOREIGN_PASSPORT: "FOREIGN_PASSPORT",
    FOREIGN_ID: "FOREIGN_ID"
});

export function getDocumentNameByIdType(idType) {
    switch (idType) {
        case IdTypeEnum.SA_ID:
            return "South African ID Document";
        case IdTypeEnum.ASYLUM_PAPER:
            return "Asylum Document";
        case IdTypeEnum.FOREIGN_PASSPORT:
            return "Foreign Passport";
        case IdTypeEnum.FOREIGN_ID:
            return "Foreign ID";
        default:
            return "Identity Document"
    }
}

export default IdTypeEnum;